<style>
    .item {
        cursor: move;
    }

    .chosen {
        cursor: grab;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-md-3">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('name')}">
                    <label>
                        {{$t('Menü neve')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="menu.name">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('name')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <button class="btn btn-default" type="button" @click="addNewItem">{{$t('Új menüpont hozzáadása')}}</button>
                <draggable v-model="menu.items"
                           class="dragArea list-group"
                           :options="{draggable:'.item', group:'menu.items'}"
                           :element="'ul'">
                    <li v-for="(item, index) in menu.items" :key="index" class="list-group-item item">
                        <div class="form-group row">
                            <button type="button" class="btn btn-default btn-sm col-md-1" @click="openIconModal(index)"><i :class="item.icon"></i></button>
                            <input type="text" :placeholder="$t('Menüpont neve')" v-model="item.title" class="form-control col-md-4">
                            <input type="text" :placeholder="$t('Menüpont linkje')" v-model="item.link" class="form-control col-md-4">
                            <button type="button" :title="$t('Menüpont választása')" class="btn btn-info col-md-1" @click="chooseModule(index)"><i class="fa fa-link"></i> </button>
                            <button type="button" :title="$t('Törlés')" class="btn btn-danger col-md-1" @click="deleteElement(index)"><i class="fa fa-trash"></i> </button>
                            <button class="btn btn-success" :title="$t('Almenü létrehozása')" type="button" @click="addNewSubItem(index)"><i class="fa fa-chevron-down"></i> </button>
                        </div>

                        <template v-if="item.children && item.children.length > 0">
                            <menu-item :childs="item.children" :routes="routes"></menu-item>
                        </template>
                    </li>
                </draggable>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/menu/index`"></Buttons>
        <div class="modal fade" id="iconModal"  role="dialog" aria-labelledby="inputModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="inputModalLabel">{{$t('Choose Icon')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="m-portlet__body">
                            <div class="row">
                                <div class="col-md-2" v-for="(item, index) in icons" v-bind:key="index">
                                    <div class="m-demo-icon" @click="setSelectedIcon(item)">
                                        <div class="m-demo-icon__preview">
                                            <i :class="item"></i>
                                        </div>
                                        <div class="m-demo-icon__class">
                                            {{item}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('Close')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="chooseModal"  role="dialog" aria-labelledby="inputModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="chooseModalLabel">{{$t('Choose Module Route')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="m-portlet__body">
                            <div class="row">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item chosen" v-for="(item, index) in routes" v-bind:key="index" @click="setSelectedRoute(item)">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('Close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
import draggable from 'vuedraggable'
import MenuItem from './MenuItem'

export default {
  name: 'MenuForm',
  components: {MenuItem, Buttons, draggable},
  props: {
    menu: {
      type: Object,
      required: true
    },
    'menu.items': {
      type: Array
    },
    errors: {
      type: Object
    },
    url: {
      required: true
    },
    routes: {
      type: Array,
      required: true
    }
  },
  watch: {
    menu: {
      handler (val) {
      },
      deep: true
    }
  },
  data () {
    return {
      selected: 0,
      icons: [
        'flaticon-multimedia-5',
        'flaticon-multimedia-3',
        'flaticon-mail-1',
        'flaticon-email',
        'flaticon-mail',
        'flaticon-like',
        'flaticon-clock-2',
        'flaticon-delete-2',
        'flaticon-add-label-button',
        'flaticon-arrows',
        'flaticon-eye',
        'flaticon-reply',
        'flaticon-interface-11',
        'flaticon-technology-2',
        'flaticon-avatar',
        'flaticon-star',
        'flaticon-delete-1',
        'flaticon-interface-10',
        'flaticon-medical',
        'flaticon-imac',
        'flaticon-profile-1',
        'flaticon-time-3',
        'flaticon-list-3',
        'flaticon-multimedia-2',
        'flaticon-interface-9',
        'flaticon-file-1',
        'flaticon-background',
        'flaticon-chat-1',
        'flaticon-graph',
        'flaticon-pie-chart',
        'flaticon-bag',
        'flaticon-cart',
        'flaticon-warning-2',
        'flaticon-download',
        'flaticon-edit-1',
        'flaticon-visible',
        'flaticon-line-graph',
        'flaticon-statistics',
        'flaticon-paper-plane',
        'flaticon-cogwheel-2',
        'flaticon-lifebuoy',
        'flaticon-settings-1',
        'flaticon-menu-button',
        'flaticon-user',
        'flaticon-apps',
        'flaticon-clock-1',
        'flaticon-close',
        'flaticon-pin',
        'flaticon-circle',
        'flaticon-interface-8',
        'flaticon-technology-1',
        'flaticon-danger',
        'flaticon-exclamation-square',
        'flaticon-cancel',
        'flaticon-calendar-3',
        'flaticon-warning-sign',
        'flaticon-more-1',
        'flaticon-exclamation-2',
        'flaticon-cogwheel-1',
        'flaticon-more-v2',
        'flaticon-add-circular-button',
        'flaticon-facebook-letter-logo',
        'flaticon-twitter-logo',
        'flaticon-linkedin-logo',
        'flaticon-skype-logo',
        'flaticon-up-arrow-1',
        'flaticon-support',
        'flaticon-piggy-bank',
        'flaticon-confetti',
        'flaticon-gift',
        'flaticon-rocket',
        'flaticon-puzzle',
        'flaticon-computer',
        'flaticon-alert-2',
        'flaticon-alert-off',
        'flaticon-map',
        'flaticon-interface-7',
        'flaticon-graphic-2',
        'flaticon-cogwheel',
        'flaticon-alert-1',
        'flaticon-folder-4',
        'flaticon-interface-6',
        'flaticon-interface-5',
        'flaticon-calendar-2',
        'flaticon-time-2',
        'flaticon-signs-2',
        'flaticon-calendar-1',
        'flaticon-chat',
        'flaticon-infinity',
        'flaticon-list-2',
        'flaticon-bell',
        'flaticon-delete',
        'flaticon-squares-4',
        'flaticon-clipboard',
        'flaticon-shapes',
        'flaticon-comment',
        'flaticon-squares-3',
        'flaticon-mark',
        'flaticon-signs-1',
        'flaticon-squares-2',
        'flaticon-business',
        'flaticon-browser',
        'flaticon-car',
        'flaticon-light',
        'flaticon-information'
      ]
    }
  },
  methods: {
    addNewItem () {
      this.menu.items.push({
        id: 9999,
        title: '',
        children: [],
        icon: 'flaticon-more-1',
        link: ''
      })
      this.$emit('onUpdateMenu', this.menu)
    },
    addNewSubItem (index) {
      this.menu.items[index].children.push({
        id: 9999,
        title: '',
        children: [],
        icon: 'flaticon-more-1',
        link: ''
      })
      this.$emit('onUpdateMenu', this.menu)
    },
    deleteElement (index) {
      this.menu.items.splice(index, 1)
    },
    setSelectedRoute (item) {
      this.menu.items[this.selected].link = item
      this.selected = 0
      window.$('#chooseModal').modal('hide')
    },
    setSelectedIcon (item) {
      this.menu.items[this.selected].icon = item
      this.selected = 0
      window.$('#iconModal').modal('hide')
    },
    openIconModal (index) {
      this.selected = index
      window.$('#iconModal').modal('show')
    },
    chooseModule (index) {
      this.selected = index
      window.$('#chooseModal').modal('show')
    },
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    }
  },
  created: function () {
    let self = this
    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.role = res.data.data

        for (let it in self.role.acls) {
          self.acls.push(self.role.acls[it].path)
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/menu/MenuForm.vue